/* ============================================================
 * c-product-card-swipe.js
 *
 * PM 指摘 #20: SP で商品カードを左右スワイプすると 2 枚目画像表示
 *
 * 仕様:
 *   - SP のみ動作 (PC は Dawn の .media--hover-effect で hover swap 既存)
 *   - 全ページの .c-product-card に適用 (TOP / 商品一覧 / 関連商品 等)
 *   - document delegation で動的に追加されたカード (load-more 等) にも自動対応
 *   - 横スワイプ: 左 (dx < -30px) → 2 枚目表示 (`.is-secondary-image` 付与)
 *               右 (dx > 30px) → 1 枚目に戻す (`.is-secondary-image` 除去)
 *   - 縦スクロールが優先される場合 (|dy| > |dx|) はスワイプ判定しない
 *   - スワイプ判定時は次の click を抑制 (商品詳細遷移を防止)
 *
 * 関連:
 *   - assets/c-base.css (SP CSS で .is-secondary-image を画像表示切替)
 *   - snippets/c-product-card.liquid (2 枚目画像を常時レンダリング)
 * ============================================================ */
(function () {
  'use strict';

  var MIN_SWIPE_PX = 30;       // 最小スワイプ距離
  var MOVE_THRESHOLD_PX = 10;   // この距離を超えたらスワイプ候補

  var startX = 0;
  var startY = 0;
  var activeCard = null;
  var isSwipe = false;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  document.addEventListener('touchstart', function (e) {
    if (!isMobile()) return;
    var card = e.target.closest('.c-product-card');
    if (!card) return;
    var media = card.querySelector('.media--hover-effect');
    if (!media) return;
    var imgs = media.querySelectorAll('img');
    if (imgs.length < 2) return;

    activeCard = card;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isSwipe = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!activeCard) return;
    var dx = Math.abs(e.touches[0].clientX - startX);
    var dy = Math.abs(e.touches[0].clientY - startY);
    if (dx > MOVE_THRESHOLD_PX && dx > dy) {
      isSwipe = true;
    }
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!activeCard) return;
    if (isSwipe) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) >= MIN_SWIPE_PX) {
        if (dx < 0) {
          activeCard.classList.add('is-secondary-image');
        } else {
          activeCard.classList.remove('is-secondary-image');
        }
      }
    }
    activeCard = null;
  }, { passive: true });

  // スワイプ後の click を抑制 (capture phase で先取り)
  document.addEventListener('click', function (e) {
    if (isSwipe) {
      e.preventDefault();
      e.stopPropagation();
      isSwipe = false;
    }
  }, true);
})();
